module.exports = __webpack_public_path__ + "static/img/3-7.6e1f649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-7.png
// module id = jYCr
// module chunks = 1